// Item Constants
export const GROCERY_V2_ITEM_GET_REQUEST = "GROCERY_V2_ITEM_GET_REQUEST";
export const GROCERY_V2_ITEM_GET_SUCCESS = "GROCERY_V2_ITEM_GET_SUCCESS";
export const GROCERY_V2_ITEM_GET_FAIL = "GROCERY_V2_ITEM_GET_FAIL";

export const GROCERY_V2_ITEM_CREATE_REQUEST = "GROCERY_V2_ITEM_CREATE_REQUEST";
export const GROCERY_V2_ITEM_CREATE_SUCCESS = "GROCERY_V2_ITEM_CREATE_SUCCESS";
export const GROCERY_V2_ITEM_CREATE_FAIL = "GROCERY_V2_ITEM_CREATE_FAIL";

export const GROCERY_V2_ITEM_UPDATE_REQUEST = "GROCERY_V2_ITEM_UPDATE_REQUEST";
export const GROCERY_V2_ITEM_UPDATE_SUCCESS = "GROCERY_V2_ITEM_UPDATE_SUCCESS";
export const GROCERY_V2_ITEM_UPDATE_FAIL = "GROCERY_V2_ITEM_UPDATE_FAIL";

export const GROCERY_V2_ITEM_DELETE_REQUEST = "GROCERY_V2_ITEM_DELETE_REQUEST";
export const GROCERY_V2_ITEM_DELETE_SUCCESS = "GROCERY_V2_ITEM_DELETE_SUCCESS";
export const GROCERY_V2_ITEM_DELETE_FAIL = "GROCERY_V2_ITEM_DELETE_FAIL";

export const GROCERY_V2_ITEM_UPDATE_MULTIPLE_REQUEST = "GROCERY_V2_ITEM_UPDATE_MULTIPLE_REQUEST";
export const GROCERY_V2_ITEM_UPDATE_MULTIPLE_SUCCESS = "GROCERY_V2_ITEM_UPDATE_MULTIPLE_SUCCESS";
export const GROCERY_V2_ITEM_UPDATE_MULTIPLE_FAIL = "GROCERY_V2_ITEM_UPDATE_MULTIPLE_FAIL";

export const GROCERY_V2_ITEM_DELETE_CHECKED_REQUEST = "GROCERY_V2_ITEM_DELETE_CHECKED_REQUEST";
export const GROCERY_V2_ITEM_DELETE_CHECKED_SUCCESS = "GROCERY_V2_ITEM_DELETE_CHECKED_SUCCESS";
export const GROCERY_V2_ITEM_DELETE_CHECKED_FAIL = "GROCERY_V2_ITEM_DELETE_CHECKED_FAIL";

export const GROCERY_V2_ITEM_CHECK_REQUEST = "GROCERY_V2_ITEM_CHECK_REQUEST";
export const GROCERY_V2_ITEM_CHECK_SUCCESS = "GROCERY_V2_ITEM_CHECK_SUCCESS";
export const GROCERY_V2_ITEM_CHECK_FAIL = "GROCERY_V2_ITEM_CHECK_FAIL";

// Category Constants
export const GROCERY_V2_CATEGORY_GET_REQUEST = "GROCERY_V2_CATEGORY_GET_REQUEST";
export const GROCERY_V2_CATEGORY_GET_SUCCESS = "GROCERY_V2_CATEGORY_GET_SUCCESS";
export const GROCERY_V2_CATEGORY_GET_FAIL = "GROCERY_V2_CATEGORY_GET_FAIL";

export const GROCERY_V2_CATEGORY_CREATE_REQUEST = "GROCERY_V2_CATEGORY_CREATE_REQUEST";
export const GROCERY_V2_CATEGORY_CREATE_SUCCESS = "GROCERY_V2_CATEGORY_CREATE_SUCCESS";
export const GROCERY_V2_CATEGORY_CREATE_FAIL = "GROCERY_V2_CATEGORY_CREATE_FAIL";

export const GROCERY_V2_CATEGORY_UPDATE_REQUEST = "GROCERY_V2_CATEGORY_UPDATE_REQUEST";
export const GROCERY_V2_CATEGORY_UPDATE_SUCCESS = "GROCERY_V2_CATEGORY_UPDATE_SUCCESS";
export const GROCERY_V2_CATEGORY_UPDATE_FAIL = "GROCERY_V2_CATEGORY_UPDATE_FAIL";

export const GROCERY_V2_CATEGORY_DELETE_REQUEST = "GROCERY_V2_CATEGORY_DELETE_REQUEST";
export const GROCERY_V2_CATEGORY_DELETE_SUCCESS = "GROCERY_V2_CATEGORY_DELETE_SUCCESS";
export const GROCERY_V2_CATEGORY_DELETE_FAIL = "GROCERY_V2_CATEGORY_DELETE_FAIL";

export const GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_REQUEST = "GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_REQUEST";
export const GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_SUCCESS = "GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_SUCCESS";
export const GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_FAIL = "GROCERY_V2_CATEGORY_UPDATE_MULTIPLE_FAIL";

// Favorites Constants
export const GROCERY_V2_FAVORITES_GET_REQUEST = "GROCERY_V2_FAVORITES_GET_REQUEST";
export const GROCERY_V2_FAVORITES_GET_SUCCESS = "GROCERY_V2_FAVORITES_GET_SUCCESS";
export const GROCERY_V2_FAVORITES_GET_FAIL = "GROCERY_V2_FAVORITES_GET_FAIL";

export const GROCERY_V2_FAVORITES_CREATE_REQUEST = "GROCERY_V2_FAVORITES_CREATE_REQUEST";
export const GROCERY_V2_FAVORITES_CREATE_SUCCESS = "GROCERY_V2_FAVORITES_CREATE_SUCCESS";
export const GROCERY_V2_FAVORITES_CREATE_FAIL = "GROCERY_V2_FAVORITES_CREATE_FAIL";

export const GROCERY_V2_FAVORITES_DELETE_REQUEST = "GROCERY_V2_FAVORITES_DELETE_REQUEST";
export const GROCERY_V2_FAVORITES_DELETE_SUCCESS = "GROCERY_V2_FAVORITES_DELETE_SUCCESS";
export const GROCERY_V2_FAVORITES_DELETE_FAIL = "GROCERY_V2_FAVORITES_DELETE_FAIL";

// Undo Constants
export const GROCERY_V2_UNDO_LIST_SUCCESS = "GROCERY_V2_UNDO_LIST_SUCCESS";
export const GROCERY_V2_UNDO_LIST_FAIL = "GROCERY_V2_UNDO_LIST_FAIL";
